import React from 'react'

import { Heading } from '../components/Heading';
import Channels from '../components/Channels';

export  function Delivery() {

  const title = 'Delivery';
  return (
        <>
          <Heading title={title}/>
          <div className="container">
            <Channels/>
          </div>
        </>
        
      )
  }
  
  export default Delivery